import { useEffect } from "react";

const SITE = "IslandHop Technologies";

export default function useSeo({ title, description, image }) {
  useEffect(() => {
    if (title) document.title = `${title} · ${SITE}`;

    const setMeta = (name, content, attr = "name") => {
      if (!content) return;
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    if (description) {
      setMeta("description", description);
      setMeta("og:description", description, "property");
      setMeta("twitter:description", description, "name");
    }
    if (title) {
      const full = `${title} · ${SITE}`;
      setMeta("og:title", full, "property");
      setMeta("twitter:title", full, "name");
    }
    if (image) {
      setMeta("og:image", image, "property");
      setMeta("twitter:image", image, "name");
      setMeta("twitter:card", "summary_large_image", "name");
    }
    setMeta("og:type", "website", "property");
    setMeta("og:site_name", SITE, "property");
  }, [title, description, image]);
}
